// Branded placeholder shown when an image URL fails to load (e.g. dead old-site media).
const SVG = `<svg xmlns='http://www.w3.org/2000/svg' width='1200' height='675'><rect width='100%' height='100%' fill='#f3f4f6'/><g text-anchor='middle' font-family='Georgia, serif'><text x='600' y='330' font-size='46' font-weight='bold' fill='#111111'>PICTURETHIS<tspan fill='#ef1831'>INK</tspan></text><text x='600' y='372' font-size='18' fill='#9ca3af' font-family='Arial, sans-serif'>Image unavailable</text></g></svg>`;

export const IMAGE_FALLBACK = `data:image/svg+xml,${encodeURIComponent(SVG)}`;

export function onImgError(e) {
  const el = e.currentTarget;
  if (el.dataset.fallbackApplied) return; // avoid infinite loop
  el.dataset.fallbackApplied = "1";
  el.src = IMAGE_FALLBACK;
}
